import { useTranslation } from "react-i18next";
import i18n from "src/i18n/config";
import { z } from "zod";

import { FileContentType } from "@dashboard/files/types";
import { PrebuiltBootAnimationModule, Product } from "@dashboard/products/types";

import { ModuleFileDialog, ModuleFileFormValues } from "../ModuleFileDialog";

const schema = z.object({
    fileId: z.string({ message: i18n.t("common:validation.fieldRequired") }),
});

type Props = {
    product: Product | null;
    open: boolean;
    onToggle: (value: boolean) => void;
};

const contentTypes = [
    FileContentType.ZipCompressedV2,
    FileContentType.Zip,
    FileContentType.ZipMultipart,
    FileContentType.ZipCompressed,
];

export const BootAnimationDialog = (props: Props) => {
    const { t } = useTranslation(["modals"]);

    const currentModule = props.product?.customBuildConfig?.modules.find(
        (item): item is PrebuiltBootAnimationModule => item.type === "prebuilt_bootanimation",
    );

    return (
        <ModuleFileDialog<ModuleFileFormValues, PrebuiltBootAnimationModule>
            product={props.product}
            module={currentModule ?? null}
            open={props.open}
            onToggle={props.onToggle}
            title={t("modals:manageProductModules.bootAnimation.title")}
            description={t("modals:manageProductModules.bootAnimation.description")}
            noFilesAvailable={t("modals:manageProductModules.bootAnimation.noFilesAvailable")}
            contentTypes={contentTypes}
            schema={schema}
            newModuleDefaults={{ type: "prebuilt_bootanimation", name: "boot_animation", tags: ["Own"] }}
            buildModuleValues={(_file, sourceId) => ({ sourceId })}
        />
    );
};
